import $ from "jquery";

export default function productImages() {
    $(".product-siblings").each(function () {
        $(this).attr("data-pxapm-slider-children", $(this).children().length);
        
        $(this).slick({
            mobileFirst: true,
            slidesToScroll: 1,
            slidesToShow: 1,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3,
                    },
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 5,
                    },
                },
            ],
        });
    });
    
}
